import React, { ReactNode } from 'react';
import clsx from 'clsx';

import {
  Button as MaterialButton,
  ButtonProps,
  CircularProgress,
} from '@mui/material';

import { useStyles } from './AppButton.styles';
import theme from '../../../styles/theme';

interface ICustomButtonProps extends ButtonProps {
  loader?: boolean;
}

export function Button({
  loader = false,
  children,
  variant = 'contained',
  className,
  ...props
}: ICustomButtonProps) {
  const { classes } = useStyles(theme);
  return (
    <MaterialButton
      variant={variant}
      className={clsx(classes.button, className)}
      {...props}
      disabled={props.disabled || loader}>
      {loader ? (
        <CircularProgress className={classes.circularProgress} size="24px" />
      ) : (
        children
      )}
    </MaterialButton>
  );
}

export default Button;
